import { FlexColumn, FullContainer } from '@gorila-shared-ui/components';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { accountState } from '../../../storage/account';
import { ChangePasswordForm } from '../../ui/ChangePasswordForm';
import { ProfileForm } from './ProfileForm';

export function Profile() {
  const { css, theme } = useStyles();
  const account = useRecoilValue(accountState);
  const [changePassword, setChangePassword] = useState(false);

  if (!account) return null;

  return (
    <FullContainer verticalFlex>
      <FlexColumn
        classNames={css({
          flex: 1,
          overflow: 'hidden',
          [theme.mediaQuery.large]: {
            maxWidth: '50%',
          },
          [theme.mediaQuery.extraLarge]: {
            maxWidth: '40%',
          },
        })}
      >
        {account && !changePassword ? (
          <ProfileForm
            user={account}
            changePassword={setChangePassword}
          />
        ) : (
          <ChangePasswordForm
            user={account}
            onCancel={setChangePassword}
          />
        )}
      </FlexColumn>
    </FullContainer>
  );
}
